import { useState } from 'react'

export function useSiderCollapse() {
  const [collapsed, setCollapsed] = useState<boolean>(false)
  const toggle = () => {
    setCollapsed((prev) => !prev)
  }
  return { collapsed, toggle }
}
